<template>
  <vue3-progress-bar></vue3-progress-bar>
  <router-view />
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>
